import { useEffect, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigation/types";
import { useAuthFB } from "../../context/Auth/AuthFbContext";
import { useAuth0 } from "../Login/useAuth0";

export function useProfile() {
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>();
  const { logout: logoutFB } = useAuthFB();
  const { userInfo } = useAuth0();

  const [user, setUser] = useState({
    name: "",
    email: "",
    avatar: "",
    photo: "",
    manager: {}
  });

  useEffect(() => {

    if (userInfo) {
      setUser({
        name: userInfo.name || "",
        email: userInfo.email || "",
        avatar: userInfo.picture || "",
        photo: userInfo.photo || "", // Assuming 'photo' uses the same value as 'picture'
        manager: userInfo.manager || {}

      });
    }
  }, [userInfo]);

  const logout = async () => {
    console.log("🔒 Cerrando sesión...");
    await logoutFB();
    navigation.reset({ index: 0, routes: [{ name: "Landing" }] });
  };

  return {
    user,
    logout,
  };
}